<template>
  <div>
    <form>
      <v-layout wrap>
        <v-flex xs12>
          <v-text-field value="Text answer" disabled></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout v-if="switch1">
        <v-flex xs12 sm6 md2>
          <v-select
            :items="item1"
            label=""
            v-model.lazy="openEndedData.text_type"
            :rules="[(v) => !!v || 'Text type is required!']"
            @change="item($event)"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md5>
          <v-select
            :items="val"
            v-model.lazy="openEndedData.condition"
            label=""
            :rules="[(v) => !!v || 'This field is required!']"
            @change="selectItem($event)"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            v-if="textInput"
            :rules="[(v) => !!v || 'This field is required!']"
            v-model.lazy="openEndedData.conditional_text"
            label="Text"
            @keyup="onChangeField()"
          ></v-text-field>
          <v-text-field
            v-if="intInput"
            :rules="[(v) => !!v || 'This field is required!']"
            v-model.lazy="openEndedData.conditional_number"
            label="Number"
            @keyup="onChangeField()"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field
            label="Custom error text"
            v-model="openEndedData.custom_error"
            @keyup="onChangeField()"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title class="grey lighten-3">
          <span class="material-icons">
            event
          </span>
          <button>option</button>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout>
            <v-flex xs4>
              <v-switch
                v-model="switch1"
                :label="`Response validation`"
              ></v-switch>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </form>
  </div>
</template>

<script>
export default {
  props: ["openEndedInfo"],
  data: () => ({
    switch1: false,
    val: [],
    openEndedData: [
      {
        text_type: null,
        condition: null,
        conditional_number: null,
        conditional_text: null,
        custom_error: null,
      },
    ],

    textInput: false,
    intInput: false,

    item1: ["Number", "Text", "Length"],
    item2: [
      "Greater than",
      "Greater than or equal to",
      "Less than",
      "Less than or equal to",
      "Equal to",
      "Not equal to",
    ],
    item3: ["Contains", "Doesn't contains", "Email Address", "URL"],
    item4: ["Maximum character count", "Minimum character count"],
  }),
  created() {
    if(this.openEndedInfo){
    this.initialize();
    }
  },
  methods: {
    initialize(){
      // this.switch1 = true;
      // console.log("from initialize");
    // console.log(this.openEndedInfo);
    if(this.openEndedInfo !=''){
      this.switch1 = false;
    }
      this.openEndedData.text_type = this.openEndedInfo.text_type;
      this.openEndedData.condition = this.openEndedInfo.condition;
      this.openEndedData.conditional_number = this.openEndedInfo.conditional_number;
      this.openEndedData.conditional_text = this.openEndedInfo.conditional_text;
      this.openEndedData.custom_error = this.openEndedInfo.custom_error;
      if (this.openEndedInfo.text_type === "Number") {
        this.val = this.item2;
      } else if (this.openEndedInfo.text_type === "Text") {
        this.val = this.item3;
      } else {
        this.val = this.item4;
      }

      if (this.openEndedData.condition === "Contains" || this.openEndedData.condition == "Doesn't contains") {
        // console.log('ok');
        this.intInput = false;
        this.textInput = true;
      } else {
        this.textInput = false;
        this.intInput = true;
      }
    },
    item(event) {
      if (event === "Number") {
        this.val = this.item2;
      } else if (event === "Text") {
        this.val = this.item3;
      } else {
        this.val = this.item4;
      }
    },
    selectItem(event) {
      if (event === "Contains" || event == "Doesn't contains") {
        // console.log('ok');
        this.intInput = false;
        this.textInput = true;
      } else {
        this.textInput = false;
        this.intInput = true;
      }
      this.$emit("change", this.openEndedData);
    },
    onChangeField() {
      this.$emit("change", this.openEndedData);
    },
  },
};
</script>
